// extracted by mini-css-extract-plugin
export default {"banner":"or0wvuXWUjrB5jie6kTo","pulse":"oPxvDYjdhjuYtMvWUiAX"};